import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export default makeStyles()((theme: Theme) => ({
  depositDetailWrapper: {
    position: 'relative',
    marginTop: theme.spacing(2),

    '&:first-of-type': {
      marginTop: theme.spacing(0.5)
    },

    '&:not(:last-of-type)': {
      paddingBottom: theme.spacing(1.5)
    }
  },
  depositDetailLabelText: {
    textTransform: 'uppercase',
    color: theme.palette.primary.main
  },
  depositDetailValueText: {
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    whiteSpace: 'nowrap'
  },
  descriptionDeposit: {
    color: theme.palette.primary.main,
    fontSize: '12px'
  }
}))
